import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './cargarLayouts.css';
import logoImg from '../images/logo.png';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { PopoverHeader, ProgressBar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import icono1 from '../images/iconosLayouts/icono1.jpeg';
import icono2 from '../images/iconosLayouts/icono2.jpeg';
import icono3 from '../images/iconosLayouts/icono3.jpeg';
import icono4 from '../images/iconosLayouts/icono4.jpeg';
import icono5 from '../images/iconosLayouts/icono5.jpeg';
import icono6 from '../images/iconosLayouts/icono6.jpeg';

const iconos = [icono1, icono2, icono3, icono4, icono5, icono6];

function CargarLayouts() {
  const navigate = useNavigate(); // Hook para navegar entre rutas
  const [dragging, setDragging] = useState(false);
  const [popoverContent, setPopoverContent] = useState('');
  const [showPopover, setShowPopover] = useState({});
  const [progress, setProgress] = useState({});
  const fileInputRefs = useRef([]);
  const [circleStates, setCircleStates] = useState({}); // Estado para las clases del círculo

  const handleDragEvents = (e) => {
    e.preventDefault();
    if (e.type === 'dragover') setDragging(true);
    if (e.type === 'dragleave' || e.type === 'drop') setDragging(false);

    if (e.type === 'drop') {
      const files = e.dataTransfer.files;
      const validExtensions = ['.csv', '.xls', '.xlsx'];
      const validFiles = Array.from(files).filter(file =>
        validExtensions.some(ext => file.name.toLowerCase().endsWith(ext))
      );

      if (validFiles.length > 0) {
        console.log('Archivos válidos cargados:', validFiles);
      } else {
        alert('Solo se permiten archivos CSV, XLS o XLSX');
      }
    }
  };

  useEffect(() => {
    window.addEventListener('dragover', handleDragEvents);
    window.addEventListener('dragleave', handleDragEvents);
    window.addEventListener('drop', handleDragEvents);

    return () => {
      window.removeEventListener('dragover', handleDragEvents);
      window.removeEventListener('dragleave', handleDragEvents);
      window.removeEventListener('drop', handleDragEvents);
    };
  }, []);

  const handleFileUpload = async (index, apiEndpoint) => {
    const fileInput = fileInputRefs.current[index];
    const files = fileInput.files;

    if (files.length === 0) {
      setPopoverContent('No se seleccionó ningún archivo.');
      setShowPopover({ [index]: true });
      hidePopoverWithTimeout(index, false);
      return;
    }

    const formData = new FormData();
    formData.append('file', files[0]);

    // Cambiar el estado del círculo a "cargaIncompleta" (cargando)
    setCircleStates(prev => ({ ...prev, [index]: 'cargaIncompleta' }));

    let progressValue = 0;
    const interval = setInterval(() => {
      progressValue += 10;
      setProgress(prev => ({ ...prev, [index]: progressValue }));

      if (progressValue >= 90) {
        clearInterval(interval);
        setTimeout(() => {
          setProgress(prev => ({ ...prev, [index]: 0 }));
          setShowPopover({ [index]: false });
        }, 3000);
      }
    }, 500);

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        body: formData,
      });

      clearInterval(interval);
      setProgress(prev => ({ ...prev, [index]: 100 }));

      const contentDisposition = response.headers.get('content-disposition');
      if (contentDisposition && contentDisposition.includes('attachment')) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setPopoverContent('Archivo descargado correctamente.');
      } else {
        const result = await response.json();
        setPopoverContent('Envío exitoso: ' + JSON.stringify(result));
      }

      // Cambiar el estado del círculo a "cargaCompleta"
      setCircleStates(prev => ({ ...prev, [index]: 'cargaCompleta' }));
    } catch (error) {
      setPopoverContent('Error al enviar el archivo: ' + error.message);

      // Dejar el estado en "cargaInactiva" si falla
      setCircleStates(prev => ({ ...prev, [index]: 'cargaInactiva' }));
    }

    setShowPopover({ [index]: true });
    setTimeout(() => setShowPopover({ [index]: false }), 0);
  };

  const hidePopoverWithTimeout = (index, resetProgress = true) => {
    setTimeout(() => {
      setShowPopover({ [index]: false });
      if (resetProgress) setProgress(prev => ({ ...prev, [index]: 0 }));
    }, 2000);
  };

  const renderDropBox = (title, id, apiEndpoint, iconIndex) => {
    const circleClass = circleStates[id] || 'cargaInactiva'; // Clase dinámica para el círculo
    return (
      <div className="accordion-item">
        <h2 className="accordion-header d-flex align-items-center">
          <img 
            src={iconIndex}  
            className="ms-2 me-2" 
            style={{ width: '30px', height: '30px', objectFit: 'cover' }} 
            alt="Icono"
          />
          <button
            className="accordion-button collapsed d-flex justify-content-between align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${id}`}
            aria-expanded="false"
            aria-controls={`collapse${id}`}
            style={{ width: '100%' }}
          >
            {title}
           
          </button>
          <div className={`circuloCarga me-4 mb-1 ${circleClass}`}></div> {/* Círculo dinámico */}
        </h2>
        <div id={`collapse${id}`} className="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div className="accordion-body">
            <div className="drop-file-box text-center p-5 border rounded cajaCarga">
              <i className="bi bi-upload fs-1"></i>
              <p className="mt-3">Arrastra y suelta tus archivos aquí o haz clic para seleccionarlos.</p>
              <input ref={el => fileInputRefs.current[id] = el} type="file" className="form-control fileBox mt-3" multiple />
              <ProgressBar now={progress[id] || 0} label={`${progress[id] || 0}%`} className="mt-5" variant="success" />
              <OverlayTrigger
                show={showPopover[id] || false}
                placement="right"
                overlay={<Popover className='custom-popover'><PopoverHeader>Respuesta <i className="bi bi-x-lg" style={{ cursor: 'pointer'}} onClick={() => setShowPopover({ [id]: false })}></i></PopoverHeader><Popover.Body>{popoverContent}</Popover.Body></Popover>}
              >
                <button className="btn btn-primary botonEnviar mt-5" onClick={() => handleFileUpload(id, apiEndpoint)}>Enviar Archivos</button>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={dragging ? 'dragging' : ''}>
      <div className="container w-100 text-center">
        <div className="row mt-5 g-2 g-lg-3 align-items-center">
          <div className="col-4">
            <div className="p-3"><img src={logoImg} alt="Perfil" /></div>
          </div>
          <div className="col-8 d-flex align-items-center">
            <h1 className="p-3 texto-principal fw-bold">Bienvenido al Sistema de Información Estadística Infográfica</h1>
          </div>
        </div>
      </div>
      <hr />
      <center>
        <div className="accordion w-50" id="accordionExample">
          {renderDropBox('1. Cargar Centros de Trabajos', 0, '/api/CentroDeTrabajo/CargaLayoutDeCentrosDeTrabajo', icono1)}
          {renderDropBox('2. Cargar Regiones', 1, '/api/DatosRegionales/CargaLayoutDatosRegionales', icono4)}
          {renderDropBox('3. Cargar Municipios', 2, '/api/DatosRegionales/CargaLayoutDatosRegionales', icono3)}
          {renderDropBox('4. Cargar Instituciones', 3, '/api/Institucion/CargaCatalogoInstituciones', icono2)}
          {renderDropBox('5. Cargar Personas', 4, '/api/Persona/CargaLayoutDePersonas', icono5)}
          {renderDropBox('6. Cargar Plantilla Nomina', 5, '/api/PlantillaNominaTotal/CargaLayoutPlantillaNominaTotal', icono3)}
          {renderDropBox('7. Cargar Recursos', 6, '/api/Recurso/CargaLayoutDeRecursosDeLaInstitucion', icono6)}
        </div>
        <br />
        <button className='opciones' onClick={() => navigate('../menu')}> Volver</button>
      </center>
    </div>
  );
}

export default CargarLayouts;
